import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { CustomEvent } from 'src/app/parameters/custom-events/custom-event.model';
import { RoleName } from 'src/app/parameters/users/shared/models';
import { Choice } from 'src/app/shared/components/select/choice.model';
import { Company } from 'src/app/shared/models/company';
import { ScenarioSimpleInfo } from '../../shared/models';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
  @Input() roles: RoleName[];
  @Input() scenarios: ScenarioSimpleInfo[];
  @Input() customEvents: CustomEvent[];
  @Input() selectedTab: number;
  @Input() navigationMode: string;
  company: Company;
  routingTagItems: Choice[];
  routingTagLabel: string;

  // routing for tabs
  parentState = 'auth.alcmeon.fuse.metrics-and-reports.metric-reports';
  states = [`${this.parentState}.overview`, `${this.parentState}.logged-users`, `${this.parentState}.reports`];

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private customRouter: CustomRouter,
    @Inject('DropdownItemsFactory') private dropdownItemsService: any,
    @Inject('TopToolbarFactory') private topToolbarService: any
  ) {}

  ngOnInit() {
    this.topToolbarService.setTitleTranslation('parameters/links_menu/reports', null);
    this.company = this.alcmeonContextService.getCompany();
    const routingTagGroups = this.company.tags_groups.filter(tg => tg.is_routing === 1);
    if (routingTagGroups.length > 0) {
      const routingTagList = this.dropdownItemsService.buildTagItems(routingTagGroups)[0];
      this.routingTagItems = routingTagList.items[0].subitems;
      this.routingTagLabel = routingTagList.label;
    }
  }

  tabChange(event: MatTabChangeEvent) {
    // change state (=> the url), without reloading
    this.customRouter.go(this.states[event.index], {}, { location: 'replace', notify: false });
  }
}
